<template>
  <div class="position-relative">
    <BaseTopLine> </BaseTopLine>
    <div class="py-10 px-15 d-flex gap-15 align-items-center border-top" style="background-color: #1d1e2c"
      ref="topFilter">
      <div class="d-flex gap-5 flex-column pe-10 border-end border-muted">
        <span class="text-white">{{ dataLang["reg_contract_main_1"] }}</span>
        <div class="d-flex gap-5 flex-grow-1">
          <BaseInputNew placeholder="" style="width: 100px" @input="fillFilter" inputClass="bg-transparent text-white"
            inputName="contracts__id" value="" nameSign="" />
        </div>
      </div>
      <div class="d-flex gap-5 flex-column pe-10 border-end border-muted">
        <span class="text-white">{{ dataLang["reg_contract_main_2"] }}</span>
        <div class="d-flex gap-5 flex-grow-1">
          <BaseDatePicker v-model="filterTimes.contractsCreateStart" type="date"
            class="idiots-class-for-input-date top-filter-input-date" lang="ru" style="width: 100px" value-type="format"
            :format="`${userSetting.company__tempalte_date}`"
            @change="(date) => (filterTimes.contractsCreateStart = date)"></BaseDatePicker>
          <div class="text-white">-</div>

          <BaseDatePicker v-model="filterTimes.contractsCreateEnd" type="date"
            class="idiots-class-for-input-date top-filter-input-date" lang="ru" style="width: 100px" value-type="format"
            :format="`${userSetting.company__tempalte_date}`"
            @change="(date) => (filterTimes.contractsCreateEnd = date)"></BaseDatePicker>
        </div>
      </div>
      <div class="d-flex gap-5 flex-column pe-10 border-end border-muted">
        <span class="text-white">{{ dataLang["reg_contract_main_3"] }}</span>
        <div class="d-flex gap-5 flex-grow-1">
          <BaseInputNew placeholder="" style="width: 112px" @input="fillFilter" inputClass="bg-transparent text-white"
            :additionalParams="{ type: 'like' }" inputName="vehicles__gosnumber" value="" nameSign="" />
        </div>
      </div>
      <div class="d-flex gap-5 flex-column pe-10 border-end border-muted">
        <span class="text-white">{{ dataLang["reg_contract_main_4"] }}</span>
        <div class="d-flex gap-5 flex-grow-1">
          <BaseInputNew placeholder="" style="width: 112px" @input="fillFilter" inputClass="bg-transparent text-white"
            :additionalParams="{ type: 'like' }" inputName="clients__name" value="" nameSign="" />
        </div>
      </div>
      <div class="d-flex gap-5 flex-column pe-10 border-end border-muted">
        <span class="text-white">{{ dataLang["reg_contract_main_5"] }}</span>
        <div class="d-flex gap-5 flex-grow-1">
          <BaseDatePicker v-model="filterTimes.startsRateTime" type="date"
            class="idiots-class-for-input-date top-filter-input-date" lang="ru" style="width: 100px" value-type="format"
            :format="`${userSetting.company__tempalte_date}`"></BaseDatePicker>
          <div class="text-white">-</div>
          <BaseDatePicker v-model="filterTimes.endRateTime" type="date"
            class="idiots-class-for-input-date top-filter-input-date" lang="ru" style="width: 100px" value-type="format"
            :format="`${userSetting.company__tempalte_date}`"></BaseDatePicker>
        </div>
      </div>
      <div class="d-flex gap-5 flex-column pe-10 border-end border-muted">
        <span class="text-white">{{ dataLang["reg_contract_main_6"] }}</span>
        <div class="d-flex gap-5 flex-grow-1">
          <BaseDatePicker v-model="filterTimes.startsRateFinishTime" type="date"
            class="idiots-class-for-input-date top-filter-input-date" lang="ru" style="width: 100px" value-type="format"
            :format="`${userSetting.company__tempalte_date}`"></BaseDatePicker>
          <div class="text-white">-</div>
          <BaseDatePicker v-model="filterTimes.endRateFinishTime" type="date"
            class="idiots-class-for-input-date top-filter-input-date" lang="ru" style="width: 100px" value-type="format"
            :format="`${userSetting.company__tempalte_date}`"></BaseDatePicker>
        </div>
      </div>
      <div style="display: flex; align-items: self-start; gap: 10px">
        <div class="d-flex flex-column align-items-center gap-5 pt-5">
          <span class="text-white">{{ dataLang["reg_contract_main_7"] }}</span>
          <BaseCheckboxV2 placeholder="" input-name="contracts__is_damage" signClass="d-none" inverted
            @oncheckeds="fillFilter">
          </BaseCheckboxV2>
        </div>
        <div class="d-flex justify-content-between flex-column" style="height: 58px">
          <div class="btn btn-sm btn-primary action-hover px-8" @click="loadData">
            {{ dataLang["reg_contract_main_10"] }}
          </div>
          <div class="text-decoration-underline fsc-14 text-white" style="cursor: pointer" @click="resetFilter">
            Сбросить
          </div>
        </div>
      </div>
    </div>
    <div class="position-relative h-100 container-fluid" style="min-height: 250px">
      <BaseLoader v-if="localLoading"></BaseLoader>
      <div class="d-flex justify-content-between align-items-center mt-15 mb-10">
        <div class="d-flex gap-10 wp-100">
          <div class=" d-flex  align-items-center px-10"
            style="flex-grow: 1; height: 48px; background-color: #E3F0FF; color: #0C63AA;">
            {{ dataLang["reg_contract_main_11"] }}
          </div>
          <div class="base-button base-button--action fsc-16 flex-shrink-0" @click="onOpenCancelModal('client')">
            {{ dataLang["reg_contract_main_12"] }}
          </div>
          <div class="base-button base-button--action fsc-16 flex-shrink-0" @click="onOpenCancelModal('company')">
            {{ dataLang["reg_contract_main_13"] }}
          </div>

          <div class="base-button base-button--action fsc-16 flex-shrink-0" @click="onSendSms">
            {{ dataLang["reg_contract_main_14"] }}
          </div>
          <div class="base-button base-button--action fsc-16 flex-shrink-0" @click="
            activeSelectRowsMultiple.length
              ? $modal.show('sendSmsPreset')
              : ''
            ">
            {{ dataLang["reg_contract_main_15"] }}
          </div>
          <div class="base-button base-button--action fsc-16 flex-shrink-0" @click="$modal.show('modalSmsPresets')">
            {{ dataLang["reg_contract_modal_2"] }}
          </div>
          <div class="base-button base-button--action fsc-16 flex-shrink-0" @click="loadExel">
            <img :src="require(`@/assets/icons/to-exel.svg`)" width="13.5" height="13.5" />
            {{ dataLang["reg_contract_main_16"] }}
          </div>
        </div>
      </div>
      <div class="d-flex gap-15 align-items-center justify-content-end">
        <div class="text-decoration-underline fsc-16 text-dark" style="cursor: pointer" @click="resetFilter">
          {{ dataLang["register_btn_filter_off"] }}
        </div>
        <div class="btn btn-sm btn-thrity text-white fsc-16" @click="loadData(1)">
          {{ dataLang["register_btn_filter_on"] }}
        </div>
      </div>
      <div class="d-flex justify-content-between align-items-center mt-15">
        <div class="d-flex align-items-center fs-11 gap-15">
          <div class="">
            {{ dataLang["reg_contract_main_17"] }}:
            <span class="fw-bold">{{ statisticsTopTable?.total }}</span>
          </div>
          <div class="">
            {{ dataLang["reg_contract_main_18"] }}:
            <span class="fw-bold">{{ statisticsTopTable?.newClient }}</span>
            ({{
              (
                (statisticsTopTable?.newClient / statisticsTopTable?.total) *
                100
              ).toFixed(2)
            }}%)
          </div>
          <div class="">
            {{ dataLang["reg_contract_main_19"] }}:
            <span class="fw-bold">{{ statisticsTopTable?.oldClient }}</span>
            ({{
              (
                (statisticsTopTable?.oldClient / statisticsTopTable?.total) *
                100
              ).toFixed(2)
            }}%)
          </div>
          <div class="">
            {{ dataLang["reg_contract_main_20"] }}:
            <span class="fw-bold">{{ statisticsTopTable?.sirius }}</span>
            ({{
              (
                (statisticsTopTable?.sirius / statisticsTopTable?.total) *
                100
              ).toFixed(2)
            }}%)
          </div>
        </div>

        <BasePagination :page-count="numPages" :pagination-params="paginationFinesStateParams" :showLimitInput="false"
          :page-range="10" :margin-pages="0" :break-view-class="''" :click-handler="loadData" :prev-text="''"
          :next-text="''" :container-class="'custom-pagination'" :page-class="'custom-pagination__item'"
          :pageLinkClass="'custom-pagination__item-link'">
        </BasePagination>
      </div>
      <div class="text-muted fs-11 mb-5" style="max-width: 461px">
        {{ dataLang["reg_contract_main_21"] }}
      </div>
      <div class="overflow-auto__" style="min-height: 400px">
        <ve-table class="fixed-header" style="width: 100%" :columns="columns" :table-data="dataTable" :border-x="true" :border-y="true"
          row-key-field-name="contracts__id" ref="mainTable" :eventCustomOption="eventCustomOption" v-if="!localLoading"
          :checkbox-option="{
            selectedRowChange: selectedRowChange,
            selectedAllChange: selectedAllChange,
            hideSelectAll: false,
          }" :clickHighlight="false" :cell-style-option="cellStyleOption" :rowStyleOption="{
            hoverHighlight: true,
          }" :cellSelectionOption="{ enable: false }">
        </ve-table>
      </div>
    </div>

    <BaseModal name="selectRow" width="420" :clickToClose="false" :shiftY="0.5" :adaptive="true" height="295"
      classes="bg-transparent shadow-none">
      <div class="bg-white rounded-25 pt-20 pb-20 px-30 h-100">
        <div class="d-flex justify-content-end">
          <button type="button" class="btn-close" @click="$modal.hide('selectRow')"></button>
        </div>
        <div class="d-flex h-100 flex-column justify-content-center pb-10">
          <p class="text-center fw-semi-bold mb-35">
            {{ dataLang["tracker_text57"] }}
          </p>

          <div class="d-flex justify-content-center mt-15 gap-10">
            <div class="base-button base-button--action fsc-14 px-20 text-uppercase" @click="$modal.hide('selectRow')">
              {{ dataLang["tracker_text55"] }}
            </div>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal name="sendSmsPreset" width="420" @before-close="
      () => {
        activeSelectRowsMultiple = [];
        selectsFromModal.sms_presets = [];
      }
    " :clickToClose="false" :shiftY="0.5" :adaptive="true" height="295" classes="bg-transparent shadow-none">
      <div class="bg-white rounded-25 pt-20 pb-20 px-30 h-100">
        <div class="d-flex justify-content-end">
          <button type="button" class="btn-close" @click="$modal.hide('sendSmsPreset')"></button>
        </div>
        <div class="d-flex h-100 flex-column justify-content-center pb-10">
          <p class="text-center fw-semi-bold mb-15">
            {{ dataLang["reg_contract_main_15"] }}
          </p>
          <BaseSelect style="width: 100%" placeholder="" selectLabel="" deselectLabel=""
            @input="(data) => (senderSmsPreset = data)" v-model="selectsFromModal.sms_presets"
            :options="selectsDataForModal?.sms_presets" label="sms_presets__name">
            <template slot="noOptions">{{ dataLang["select_empty"] }}</template>
            <template slot="noResult">{{
              dataLang["select_search_empty"]
            }}</template><template slot="selectedLabel">{{
                dataLang["select_selected"]
              }}</template>
            <template slot="deselectLabel">{{
              dataLang["select_unselect"]
            }}</template>
          </BaseSelect>
          <div class="d-flex justify-content-center mt-30 gap-30">
            <div class="btn btn-sm btn-primary action-hover fsc-14 px-20 text-uppercase" @click="sendSms">
              {{ dataLang["orders_model_edit__btn_text7"] }}
            </div>
            <div class="base-button base-button--action fsc-14 px-20 text-uppercase"
              @click="$modal.hide('sendSmsPreset')">
              {{ dataLang["reg_contract_main_13"] }}
            </div>
          </div>
        </div>
      </div>
    </BaseModal>
    <BaseModal name="firstCancelModal" width="420" height="auto" :clickToClose="false" :shiftY="0.5" :adaptive="true"
      classes="bg-transparent shadow-none">
      <div class="bg-white rounded-25 pt-20 pb-20 px-30 h-100">
        <div class="d-flex justify-content-end">
          <button type="button" class="btn-close" @click="$modal.hide('firstCancelModal')"></button>
        </div>
        <div class="d-flex h-100 flex-column justify-content-center pb-10">
          <p class="text-center mb-15" v-html="peremText"></p>

          <div class="d-flex justify-content-center mt-30 gap-30">
            <div class="btn btn-sm btn-primary action-hover fsc-14 px-20 text-uppercase"
              @click="onAcceptCancelModal(true)">
              {{ dataLang["yes"] }}
            </div>
            <div class="base-button base-button--action fsc-14 px-20 text-uppercase" @click="
              () => {
                onAcceptCancelModal(false);
                $modal.hide('firstCancelModal');
              }
            ">
              {{ dataLang["no"] }}
            </div>
          </div>
        </div>
      </div>
    </BaseModal>
    <BaseModal name="lastCancelModal" width="420" height="auto" :clickToClose="false" :shiftY="0.5" :adaptive="true"
      classes="bg-transparent shadow-none">
      <div class="bg-white rounded-25 pt-20 pb-20 px-30 h-100">
        <div class="d-flex justify-content-end">
          <button type="button" class="btn-close" @click="$modal.hide('lastCancelModal')"></button>
        </div>
        <div class="d-flex h-100 flex-column justify-content-center pb-10">
          <p class="text-center fw-semi-bold mb-15">
            {{ peremText }}
          </p>

          <div class="d-flex justify-content-center mt-30 gap-30">
            <div class="btn btn-sm btn-primary action-hover fsc-14 px-20 text-uppercase"
              @click="onAcceptFinishCancelModal">
              {{ dataLang["yes"] }}
            </div>
            <div class="base-button base-button--action fsc-14 px-20 text-uppercase"
              @click="$modal.hide('lastCancelModal')">
              {{ dataLang["no"] }}
            </div>
          </div>
        </div>
      </div>
    </BaseModal>
    <BaseModal name="lastFinishCancelModal" width="420" height="auto" @before-close="
      () => {
        codeFromSms = '';
        activeSelectRowsMultiple = [];
      }
    " :clickToClose="false" :shiftY="0.5" :adaptive="true" classes="bg-transparent shadow-none">
      <div class="bg-white rounded-25 pt-20 pb-20 px-30 h-100">
        <div class="d-flex justify-content-end">
          <button type="button" class="btn-close" @click="$modal.hide('lastFinishCancelModal')"></button>
        </div>
        <div class="d-flex h-100 flex-column justify-content-center pb-10">
          <p class="text-center fw-semi-bold mb-15 wp-100" v-html="peremText"></p>
          <div class="d-flex gap-5" v-if="typeOpenCancel == 'client'">
            <BaseInputNew placeholder="Код" style="width: 100%" @input="(data) => (codeFromSms = data.value)"
              inputClass="" inputName="clients__name" value="" nameSign="" />
          </div>

          <div class="d-flex justify-content-center mt-30 gap-30">
            <div class="btn btn-sm btn-primary action-hover fsc-14 px-20 text-uppercase" @click="onDoneCancelModal">
              {{ dataLang["yes"] }}
            </div>
            <div class="base-button base-button--action fsc-14 px-20 text-uppercase"
              @click="$modal.hide('lastFinishCancelModal')">
              {{ dataLang["no"] }}
            </div>
          </div>
        </div>
      </div>
    </BaseModal>
    <SmsPresetsModal :type-reestr="1" />
    <ContractsModal @updateDataTable="resetFilter" />
    <TariffQuestionModal />
    <QuestionModal />
    <SendListPhoneSmsModal @close="resetFilter" />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import { VeTable } from "vue-easytable";
import GeneralService from "@/api/GeneralService";
import httpInstance from "@/http-common";
import { VueTabs, VTab } from "vue-nav-tabs/dist/vue-tabs.js";
import SmsPresetsModal from "./orders-modal/SmsPresetsModal.vue";
import ContractsModal from "./contracts-modal/ContractsModal.vue";
import TariffQuestionModal from "@/views/contracts-modal/TariffQuestionModal.vue";
import QuestionModal from "@/views/contracts-modal/QuestionModal.vue";
import dayjs from "dayjs";
import EventBus from "@/event-bus";
import SendListPhoneSmsModal from "@/components/reuse_modal/SendListPhoneSmsModal.vue";
export default {
  components: {
    VeTable,
    VueTabs,
    VTab,
    TariffQuestionModal,
    QuestionModal,
    SmsPresetsModal,
    ContractsModal,
    SendListPhoneSmsModal,
  },

  data() {
    return {
      intervalInstance: null,
      localLoading: true,
      statisticsTopTable: {},
      dataTable: [],
      activeSelectRowsMultiple: [],
      filter: [{ field: "contracts__status_id", value: [4], operator: "!=" }],
      activateTab: "",
      updatedValues: {},
      computedAllPage: 1,
      currentPage: 1,
      nameValue: "",

      filterTimes: {
        contractsCreateStart: "",
        contractsCreateEnd: "",
        startsRateTime: "",
        endRateTime: "",
        startsRateFinishTime: "",
        endRateFinishTime: "",
      },
      settingOneClick: {},
      activePagePagination: {},
      newValueCustomModal: "",
      currentId: null,
      localLoadingModal: false,
      objectsVehiclesNew: [],
      pincode: "",
      dataForModal: {},
      aboutPageInfo: null,
      fileLoadResult: null,
      dataOfErrors: null,
      senderSmsPreset: null,
      peremText: "",
      typeOpenCancel: "",
      codeFromSms: "",
      selectsDataForModal: {
        owners: [],
        typeVehicles: [],
        objectsVehicle: [],
        sms_presets: [],
      },
      selectsFromModal: {
        owners: [],
        typeVehicles: [],
        objectsVehicle: [],
        sms_presets: [],
      },
      selectsData: {
        ads: [],
        typeOrder: [],
        typeObjects: [],
        cityStart: [],
        cityEnd: [],
        placeStart: [],
        placeEnd: [],
        odometr: [],
        statuses: [],
      },
      selectsFilter: {
        ads: [],
        typeOrder: [],
        typeObjects: [],
        cityStart: [],
        cityEnd: [],
        placeStart: [],
        placeEnd: [],
        odometr: [],
        statuses: [],
      },
      eventCustomOption: {
        bodyRowEvents: ({ row, rowIndex }) => {
          return {
            dblclick: (event) => {
              console.log("CLICK EVENT FROM TABLE", row);
              this.$modal.show("contractsModal", {
                contracts__id: row.contracts__id,
                clients__id: row.clients__id,
              });
            },
          };
        },
      },
      cellStyleOption: {
        bodyCellClass: ({ row, column, rowIndex }) => {
          if (
            column.field ===
            Object.keys(row.settings).find((x) => x == column.field)
          ) {
            return row.settings[column.field];
          }
        },
      },
    };
  },
  methods: {
    selectedRowChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    selectedAllChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    onOpenCancelModal(nameCancel) {
      this.typeOpenCancel = nameCancel;
      if (this.activeSelectRowsMultiple?.length) {
        GeneralService.editOrCreate(
          `/contracts/${this.activeSelectRowsMultiple[0]}/cancel/${nameCancel}/step1`
        )
          .then((data) => {
            GeneralService.editOrCreate(
              `/contracts/${this.activeSelectRowsMultiple[0]}/cancel/${nameCancel}/step2`
            )
              .then((data) => {
                this.peremText = data.data.data.message;
                this.$modal.show("firstCancelModal");
              })
              .catch((e) => {
                // this.$modal.hide('buyTracker')
                this.$toast.error(e.response.data.message, { duration: 5000 });
              });
          })
          .catch((e) => {
            // this.$modal.hide('buyTracker')
            this.$toast.error(e.response.data.message, { duration: 5000 });
          });
      } else {
        this.$toast.error("Не выбран договор", { duration: 5000 });
        this.typeOpenCancel = "";
      }
    },
    onSendSms() {
      if (this.activeSelectRowsMultiple?.length) {
        let resultArrayListNumber = [];
        this.activeSelectRowsMultiple.forEach((acceptId) => {
          resultArrayListNumber.push(
            this.dataTable.find((x) => x.contracts__id == acceptId)
              .clients__phone
          );
        });
        this.$modal.show("sendListPhoneSmsModal", {
          numberList: [...new Set(resultArrayListNumber)],
        });
      } else {
        this.$toast.error("Не выбран(ы, {duration: 5000}) договоры");
      }
    },
    onAcceptCancelModal(type) {
      GeneralService.editOrCreate(
        `/contracts/${this.activeSelectRowsMultiple[0]}/cancel/${this.typeOpenCancel}/step3`,
        {
          confirmation: type,
        }
      )
        .then((data) => {
          if (this.typeOpenCancel == "client") {
            this.peremText = data.data.data.message;
            this.$modal.hide("firstCancelModal");
            this.$modal.show("lastFinishCancelModal");
          } else {
            this.onDoneCancelModal();
          }
        })
        .catch((e) => {
          // this.$modal.hide('buyTracker')
          this.$modal.hide("lastFinishCancelModal");
          this.$toast.error(e.response.data.message, { duration: 5000 });
        });
    },
    onAcceptFinishCancelModal(nameCancel) {
      GeneralService.editOrCreate(
        `/contracts/${this.activeSelectRowsMultiple[0]}/cancel/${this.typeOpenCancel}/step4`
      )
        .then((data) => {
          if (this.typeOpenCancel == "client") {
            this.$toast.success();
            this.$modal.hide("lastFinishCancelModal");
            this.resetFilter();
          } else {
            this.onDoneCancelModal();
          }
        })
        .catch((e) => {
          // this.$modal.hide('buyTracker')
          if (e?.response?.data) {
            this.$toast.error(e.response.data.message, { duration: 5000 });
          }
        });
    },
    onDoneCancelModal() {
      GeneralService.editOrCreate(
        `/contracts/${this.activeSelectRowsMultiple[0]}/cancel/${this.typeOpenCancel}/step4`,
        {
          ...(this.typeOpenCancel &&
            this.typeOpenCancel == "client" && { code: this.codeFromSms }),
        }
      )
        .then((data) => {
          this.$toast.success(data.data.data.message);
          this.$modal.hide("lastFinishCancelModal");
          this.$modal.hide("firstCancelModal");

          this.resetFilter();
        })
        .catch((e) => {
          // this.$modal.hide('buyTracker')

          this.$modal.hide("lastFinishCancelModal");
          this.$modal.hide("firstCancelModal");
          if (e?.response?.data) {
            this.$toast.error(e.response.data.message, { duration: 5000 });
          }
        });
    },
    sendSms() {
      if (
        Object.values(this.senderSmsPreset).length &&
        this.activeSelectRowsMultiple.length
      ) {
        Promise.all([
          this.activeSelectRowsMultiple.map((id) => {
            return GeneralService.editOrCreate(`/sms`, {
              phone: this.dataTable.find((x) => x.contracts__id == id)
                .clients__phone,
              text: this.senderSmsPreset.sms_presets__text,
            });
          }),
        ]).then((data) => {
          this.$toast.success("Выполнено");
          this.$modal.hide("sendSmsPreset");
          this.senderSmsPreset = null;
          this.selectsFromModal.sms_presets = [];
          this.activeSelectRowsMultiple = [];
        });
      } else {
        this.$toast.error("Не выбран договор или не выбран пресет", { duration: 5000 });
      }
    },
    async loadExel(urlToFetch) {
      let dataFrom = await httpInstance.get("/contracts/table/main/xlsx", {
        responseType: "blob",
      });
      const filename = new Date().toISOString();
      const url = window.URL.createObjectURL(dataFrom.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${filename}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    },
    resetFilter() {
      this.$refs.mainTable.$el
        .querySelectorAll("input.base-input--new")
        .forEach((elem, index) => {
          elem.value = "";
        });
      this.$refs.topFilter
        .querySelectorAll("input.base-input--new")
        .forEach((elem, index) => {
          elem.value = "";
        });
      this.filter = [
        { field: "contracts__status_id", value: [4], operator: "!=" },
      ];
      this.selectsFilter.trackers = [];
      this.selectsFilter.statuses = [];
      this.filterTimes = {
        contractsCreateStart: "",
        contractsCreateEnd: "",
        startsRateTime: "",
        endRateTime: "",
        startsRateFinishTime: "",
        endRateFinishTime: "",
      };
      this.activeSelectRowsMultiple = [];
      this.loadData();
    },
    onCloseModal() {
      this.currentId = null;
      this.updatedValues = {};
      this.dataForModal = {};
      this.activeSelectRowsMultiple = [];
      this.selectsFromModal.objectsVehicle = [];
      this.selectsFromModal.typeVehicles = [];
    },
    loadData() {
      this.localLoading = true;
      Promise.all([
        GeneralService.get(`/contracts/filter/ads`)
          .then((data) => {
            this.selectsData.ads = data.data.data;
            // this.selectsFilter.ads = data.data.data.rows
          })
          .catch((e) => {
            this.$toast.error(
              "Неизвестная ошибка при загрузке источников рекламы"
            );
          }),
        GeneralService.get(`/contracts/filter/order-types`)
          .then((data) => {
            let dataForSelect = [];
            for (const key in data.data.data) {
              dataForSelect.push({
                label: this.dataLang[data.data.data[key]],
                value: key,
              });
            }
            this.selectsData.typeOrder = dataForSelect;
          })
          .catch((e) => {
            this.$toast.error("Неизвестная ошибка при загрузке типов аренды", { duration: 5000 });
          }),

        GeneralService.get(`/contracts/filter/object-types`)
          .then((data) => {
            let dataForSelect = [];
            for (const key in data.data.data) {
              dataForSelect.push({
                label: this.dataLang[data.data.data[key]],
                value: key,
              });
            }
            this.selectsData.typeObjects = dataForSelect;
          })
          .catch((e) => {
            this.$toast.error(
              "Неизвестная ошибка при загрузке типов транспорта"
            );
          }),
        GeneralService.get(`/contracts/filter/cities-start`)
          .then((data) => {
            this.selectsData.cityStart = data.data.data;
          })
          .catch((e) => {
            this.$toast.error("Неизвестная ошибка при загрузке городов начала", { duration: 5000 });
          }),

        GeneralService.get(`/contracts/filter/cities-end`)
          .then((data) => {
            this.selectsData.cityEnd = data.data.data;
          })
          .catch((e) => {
            this.$toast.error(
              "Неизвестная ошибка при загрузке городов завершения"
            );
          }),
        GeneralService.get(`/contracts/filter/statuses`)
          .then((data) => {
            let dataForSelect = [];
            for (const key in data.data.data) {
              dataForSelect.push({
                label: this.dataLang[data.data.data[key]],
                value: key,
              });
            }
            this.selectsData.statuses = dataForSelect;
          })
          .catch((e) => {
            this.$toast.error(
              "Неизвестная ошибка при загрузке статусов договора"
            );
          }),

        GeneralService.get(`/presets/sms`, {
          params: {
            where: JSON.stringify([
              { field: "sms_presets__category_id", value: 1 },
            ]),
          },
        })
          .then((data) => {
            this.selectsDataForModal.sms_presets = data.data.data.rows;
          })
          .catch((e) => { }),
      ]).then(() => {
        GeneralService.get(`/contracts/table/main`, {
          params: {
            ...this.paginationFinesStateParams,
            ...(this.filter.length && {
              where: JSON.stringify([
                ...this.filter,
                this.computedDatesCreateContract,
                ...(this.computedDatesStartsContract.length && [
                  ...this.computedDatesStartsContract,
                ]),
                ...(this.computedDatesFinishContract.length && [
                  ...this.computedDatesFinishContract,
                ]),
              ]),
            }),
          },
        })
          .then((data) => {
            this.dataTable = data.data.data.rows;
            this.statisticsTopTable = data.data.data.statistics;
            this.getFinesAll(data.data.data);
            this.localLoading = false;
          })
          .catch((e) => {
            this.$toast.error("Неизвестная ошибка при загрузке таблицы", { duration: 5000 });
          });
      });
    },
    fillFilter(data) {
      if (data.name == "contracts__id") {
        this.filter[
          this.filter.findIndex((x) => x.field == "contracts__status_id")
        ] = {};
      }
      let newValueFilter =
        data.type == "like" ? `;percent;${data.value};percent;` : data.value;
      if (!this.filter.find((x) => x.field == data.name)) {
        this.filter.push({
          field: data.name,
          value: newValueFilter,
          ...(data.type == "like" && { operator: "like" }),
          ...(data.operator && { operator: data.operator }),
          ...(data.mod && { mod: data.mod }),
        });
      } else {
        this.filter[this.filter.findIndex((x) => x.field == data.name)].value =
          newValueFilter;
      }
    },

    ...mapActions("finesPagination", ["getFinesAll"]),
  },
  mounted() {
    if (this.$route.query.id) {
      this.$modal.show("contractsModal", {
        contracts__id: this.$route.query.id,
      });
    }
    this.intervalInstance = setInterval(() => {
      this.resetFilter();
    }, 600000);
  },
  unmounted() {
    clearInterval(this.intervalInstance);
    this.intervalInstance = null;
  },

  created() {
    this.loadData();
  },
  computed: {
    ...mapState("translationModule", ["dataLang"]),
    ...mapState("userSettingModule", ["userSetting"]),
    ...mapState("finesPagination", ["paginationFinesStateParams"]),
    ...mapGetters("finesPagination", ["numPages"]),

    computedDatesFinishContract() {
      return [
        this.filterTimes.startsRateFinishTime
          ? {
            field: "contracts__ends",
            value:
              this.filterTimes.startsRateFinishTime
                .split(".")
                .reverse()
                .join("-") + " 00:00",

            operator: ">=",
          }
          : {},
        this.filterTimes.endRateFinishTime
          ? {
            field: "contracts__ends",
            value:
              this.filterTimes.endRateFinishTime
                .split(".")
                .reverse()
                .join("-") + " 23:59",

            operator: "<=",
          }
          : {},
      ];
    },

    computedDatesStartsContract() {
      return [
        this.filterTimes.startsRateTime
          ? {
            field: "contracts__starts",
            value:
              this.filterTimes.startsRateTime.split(".").reverse().join("-") +
              " 00:00",

            operator: ">=",
          }
          : {},
        this.filterTimes.endRateTime
          ? {
            field: "contracts__starts",
            value:
              this.filterTimes.endRateTime.split(".").reverse().join("-") +
              " 23:59",

            operator: "<=",
          }
          : {},
      ];
    },
    computedDatesCreateContract() {
      if (
        this.filterTimes.contractsCreateStart ||
        this.filterTimes.contractsCreateEnd
      ) {
        return {
          field: "contracts__created_at",
          value: [
            this.filterTimes.contractsCreateStart
              .split(".")
              .reverse()
              .join("-") + " 00:00",
            this.filterTimes.contractsCreateEnd.split(".").reverse().join("-") +
            " 23:59",
          ],
          operator: "between",
          mod: "date",
        };
      } else {
        return {};
      }
    },

    columns() {
      return [
        {
          field: "",
          key: "a6",
          type: "checkbox",
          title: "",
          width: "2%",
          align: "center",
        },
        {
          title: this.dataLang["reg_contract_edit_31"],
          children: [
            {
              field: "contracts__id",
              key: "1636",
              title: this.dataLang["reg_contract_main_33"],
              align: "center",
              width: "2%",
              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div class={"h-100"}>
                    <div style={"height: 20px"}></div>
                    <div class={"text-center"}>{column.title}</div>

                    <BaseInputNew
                      placeholder=""
                      disabled={false}
                      onInput={this.fillFilter}
                      additionalParams={{ type: "like" }}
                      inputName={"contracts__id"}
                      value={""}
                      nameSign={""}
                    />
                  </div>
                );
              },
            },
            {
              field: "contract_statuses__status",
              key: "1633122461",
              title: this.dataLang["reg_contract_main_32"],
              align: "center",
              width: "6%",

              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },

              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div style={"padding-top: 50px"}>
                      <div class={"text-center"}>{column.title}</div>
                      <BaseSelect
                        vModel={this.selectsFilter.statuses}
                        onInput={(e, w) => {
                          this.filter.splice(
                            this.filter.findIndex(
                              (x) => x.field == "contracts__status_id"
                            ),
                            1
                          );
                          if (
                            !this.filter.find(
                              (x) => x.field == "contracts__status_id"
                            )
                          ) {
                            this.filter.push({
                              field: "contracts__status_id",
                              value: e.value,
                            });
                          } else {
                            this.filter[
                              this.filter.findIndex(
                                (x) => x.field == "contracts__status_id"
                              )
                            ].value = e.value;
                          }
                        }}
                        style={"width: 100%"}
                        label={"label"}
                        placeholder={""}
                        id={"id"}
                        selectLabel={""}
                        deselectLabel={""}
                        options={this.selectsData.statuses}
                      ></BaseSelect>
                    </div>
                  </div>
                );
              },
              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                  <span
                    title={
                      this.dataLang[row.contract_statuses__status]
                        .charAt(0)
                        .toUpperCase() +
                      this.dataLang[row.contract_statuses__status].slice(1)
                    }
                  >
                    {this.dataLang[row.contract_statuses__status]
                      .charAt(0)
                      .toUpperCase() +
                      this.dataLang[row.contract_statuses__status].slice(1)}
                  </span>
                );
              },
            },
            {
              field: "contracts__created_at",
              key: "15373",
              title: this.dataLang["reg_contract_main_34"],
              align: "center",
              width: "6%",

              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div class={"text-center"}>{column.title}</div>
                  </div>
                );
              },
              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                  <span
                    title={
                      row.contracts__created_at
                        ? dayjs(row.contracts__created_at)
                          .utc(true)
                          .utcOffset(Number(this.userSetting.company__utc))
                          .format(
                            `${this.userSetting.company__tempalte_date} HH:mm`
                          )
                        : ""
                    }
                  >
                    {row.contracts__created_at
                      ? dayjs(row.contracts__created_at)
                        .utc(true)
                        .utcOffset(Number(this.userSetting.company__utc))
                        .format(
                          `${this.userSetting.company__tempalte_date} HH:mm`
                        )
                      : ""}
                  </span>
                );
              },
            },
            {
              field: "ads__name",
              key: "1721",
              title: this.dataLang["reg_contract_main_35"],
              align: "center",
              width: "6%",
              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div style={"height: 20px"}></div>
                    <div class={"text-center"}>{column.title}</div>
                    <BaseSelect
                      vModel={this.selectsFilter.ads}
                      onInput={(e, w) => {
                        if (!this.filter.find((x) => x.field == "ads__id")) {
                          this.filter.push({
                            field: "ads__id",
                            value: e.id,
                          });
                        } else {
                          this.filter[
                            this.filter.findIndex((x) => x.field == "ads__id")
                          ].value = e.id;
                        }
                      }}
                      style={"width: 100%"}
                      label={"name"}
                      placeholder={""}
                      id={"id"}
                      selectLabel={""}
                      deselectLabel={""}
                      options={this.selectsData.ads}
                    ></BaseSelect>
                  </div>
                );
              },
            },
            {
              field: "employees__name",
              key: "137246",
              title: this.dataLang["reg_contract_main_36"],
              align: "center",
              width: "6%",
              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div class={"h-100"}>
                    <div style={"height: 20px"}></div>
                    <div class={"text-center"}>{column.title}</div>

                    <BaseInputNew
                      placeholder=""
                      disabled={false}
                      onInput={this.fillFilter}
                      additionalParams={{ type: "like" }}
                      inputName={"employees__name"}
                      value={""}
                      nameSign={""}
                    />
                  </div>
                );
              },
            },
          ],
        },
        {
          title: this.dataLang["reg_contract_main_27"],
          children: [
            {
              field: "order_types__name",
              key: "165315",
              title: this.dataLang["reg_contract_main_37"],
              align: "center",
              width: "4%",

              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },

              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                  <span title={this.dataLang[row.order_types__name]}>
                    {this.dataLang[row.order_types__name]}
                  </span>
                );
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div style={"height: 20px"}></div>
                    <div class={"text-center"}>{column.title}</div>
                    <BaseSelect
                      vModel={this.selectsFilter.typeOrder}
                      onInput={(e, w) => {
                        if (
                          !this.filter.find((x) => x.field == "order_types__id")
                        ) {
                          this.filter.push({
                            field: "order_types__id",
                            value: e.value,
                          });
                        } else {
                          this.filter[
                            this.filter.findIndex(
                              (x) => x.field == "order_types__id"
                            )
                          ].value = e.value;
                        }
                      }}
                      style={"width: 100%"}
                      label={"label"}
                      placeholder={""}
                      id={"id"}
                      selectLabel={""}
                      deselectLabel={""}
                      options={this.selectsData.typeOrder}
                    ></BaseSelect>
                  </div>
                );
              },
            },
            {
              field: "vehicle_types__code",
              key: "1631411",
              title: this.dataLang["reg_contract_main_38"],
              align: "center",
              width: "4%",

              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div style={"height: 20px"}></div>
                    <div class={"text-center"}>{column.title}</div>
                    <BaseSelect
                      vModel={this.selectsFilter.typeObjects}
                      onInput={(e, w) => {
                        if (
                          !this.filter.find(
                            (x) => x.field == "vehicle_types__id"
                          )
                        ) {
                          this.filter.push({
                            field: "vehicle_types__id",
                            value: e.value,
                          });
                        } else {
                          this.filter[
                            this.filter.findIndex(
                              (x) => x.field == "vehicle_types__id"
                            )
                          ].value = e.value;
                        }
                      }}
                      style={"width: 100%"}
                      label={"label"}
                      placeholder={""}
                      id={"id"}
                      selectLabel={""}
                      deselectLabel={""}
                      options={this.selectsData.typeObjects}
                    ></BaseSelect>
                  </div>
                );
              },
              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                  <span title={this.dataLang[row.vehicle_types__code]}>
                    {this.dataLang[row.vehicle_types__code]}
                  </span>
                );
              },
            },
            {
              field: "vehicles__gosnumber",
              key: "163315",
              title: this.dataLang["reg_contract_main_39"],
              align: "center",
              width: "6%",

              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div class={"h-100"}>
                    <div style={"height: 20px"}></div>
                    <div class={"text-center"}>{column.title}</div>

                    <BaseInputNew
                      placeholder=""
                      disabled={false}
                      onInput={this.fillFilter}
                      additionalParams={{ type: "like" }}
                      inputName={"vehicles__gosnumber"}
                      value={""}
                      nameSign={""}
                    />
                  </div>
                );
              },
              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                  <span
                    title={row.vehicles__gosnumber + " " + row.vehicles__name}
                  >
                    {row.vehicles__gosnumber} {row.vehicles__name}
                  </span>
                );
              },
            },
          ],
        },

        {
          title: this.dataLang["reg_contract_main_28"],
          children: [
            {
              field: "clients__name",
              key: "126341",
              title: this.dataLang["reg_contract_main_40"],
              align: "start",
              width: "6%",

              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div class={"h-100"}>
                    <div style={"height: 20px"}></div>
                    <div class={"text-center"}>{column.title}</div>

                    <BaseInputNew
                      placeholder=""
                      disabled={false}
                      onInput={this.fillFilter}
                      additionalParams={{ type: "like" }}
                      inputName={"clients__name"}
                      value={""}
                      nameSign={""}
                    />
                  </div>
                );
              },
              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                  <span
                    title={
                      "(" + row.clients__id + ")" + " " + row.clients__name
                    }
                  >
                    ({row.clients__id}) {row.clients__name}
                  </span>
                );
              },
            },
            {
              field: "clients__balance",
              key: "163161",
              title: this.dataLang["reg_contract_main_41"],
              align: "center",
              width: "4%",

              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div class={"text-center"}>{column.title}</div>
                  </div>
                );
              },
              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                  <span title={row.clients__balance?.replace(".", ",")}>
                    {row.clients__balance?.replace(".", ",")}
                  </span>
                );
              },
            },
          ],
        },

        {
          title: this.dataLang["reg_contract_main_29"],
          children: [
            {
              field: "contracts__starts",
              key: "1631261",
              title: this.dataLang["reg_contract_main_42"],
              align: "center",
              width: "6%",

              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div class={"text-center"}>{column.title}</div>
                  </div>
                );
              },
              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                  <span
                    title={
                      row.contracts__starts
                        ? dayjs(row.contracts__starts).format(
                          `${this.userSetting.company__tempalte_date} HH:mm`
                        )
                        : ""
                    }
                  >
                    {row.contracts__starts
                      ? dayjs(row.contracts__starts).format(
                        `${this.userSetting.company__tempalte_date} HH:mm`
                      )
                      : ""}
                  </span>
                );
              },
            },
            {
              field: "cities_start__name",
              key: "16311261",
              title: this.dataLang["reg_contract_main_43"],
              align: "center",
              width: "4%",

              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div style={"height: 20px"}></div>
                    <div class={"text-center"}>{column.title}</div>
                    <BaseSelect
                      vModel={this.selectsFilter.cityStart}
                      onInput={(e, w) => {
                        if (
                          !this.filter.find(
                            (x) => x.field == "cities_start__id"
                          )
                        ) {
                          this.filter.push({
                            field: "cities_start__id",
                            value: e.id,
                          });
                        } else {
                          this.filter[
                            this.filter.findIndex(
                              (x) => x.field == "cities_start__id"
                            )
                          ].value = e.id;
                        }
                      }}
                      style={"width: 100%"}
                      label={"name"}
                      placeholder={""}
                      id={"id"}
                      selectLabel={""}
                      deselectLabel={""}
                      options={this.selectsData.cityStart}
                    ></BaseSelect>
                  </div>
                );
              },
            },
            {
              field: "vehicle_places_start__address",
              key: "16312261",
              title: this.dataLang["reg_contract_main_44"],
              align: "center",
              width: "6%",

              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div class={"h-100"}>
                    <div style={"height: 20px"}></div>
                    <div class={"text-center"}>{column.title}</div>

                    <BaseInputNew
                      placeholder=""
                      disabled={false}
                      onInput={this.fillFilter}
                      additionalParams={{ type: "like" }}
                      inputName={"cities_city_as_place_start__center_address"}
                      value={""}
                      nameSign={""}
                    />
                  </div>
                );
              },
            },
          ],
        },
        {
          title: this.dataLang["reg_contract_main_30"],
          children: [
            {
              field: "contracts__ends",
              key: "163351261",
              title: this.dataLang["reg_contract_main_42"],
              align: "center",
              width: "6%",

              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div class={"text-center"}>{column.title}</div>
                  </div>
                );
              },
              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                  <span
                    title={
                      row.contracts__ends
                        ? dayjs(row.contracts__ends).format(
                          `${this.userSetting.company__tempalte_date} HH:mm`
                        )
                        : ""
                    }
                  >
                    {row.contracts__ends
                      ? dayjs(row.contracts__ends).format(
                        `${this.userSetting.company__tempalte_date} HH:mm`
                      )
                      : ""}
                  </span>
                );
              },
            },
            {
              field: "cities_end__name",
              key: "99261",
              title: this.dataLang["reg_contract_main_43"],
              align: "center",
              width: "4%",

              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div style={"height: 20px"}></div>
                    <div class={"text-center"}>{column.title}</div>
                    <BaseSelect
                      vModel={this.selectsFilter.cityEnd}
                      onInput={(e, w) => {
                        if (
                          !this.filter.find((x) => x.field == "cities_end__id")
                        ) {
                          this.filter.push({
                            field: "cities_end__id",
                            value: e.id,
                          });
                        } else {
                          this.filter[
                            this.filter.findIndex(
                              (x) => x.field == "cities_end__id"
                            )
                          ].value = e.id;
                        }
                      }}
                      style={"width: 100%"}
                      label={"name"}
                      placeholder={""}
                      id={"id"}
                      selectLabel={""}
                      deselectLabel={""}
                      options={this.selectsData.cityEnd}
                    ></BaseSelect>
                  </div>
                );
              },
            },
            {
              field: "vehicle_places_end__address",
              key: "163312261",
              title: this.dataLang["reg_contract_main_44"],
              align: "center",
              width: "6%",

              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div class={"h-100"}>
                    <div style={"height: 20px"}></div>
                    <div class={"text-center"}>{column.title}</div>

                    <BaseInputNew
                      placeholder=""
                      disabled={false}
                      onInput={this.fillFilter}
                      additionalParams={{ type: "like" }}
                      inputName={"cities_city_as_place_end__center_address"}
                      value={""}
                      nameSign={""}
                    />
                  </div>
                );
              },
            },
          ],
        },
        {
          title: this.dataLang["reg_contract_main_31"],
          children: [
            {
              field: "contracts__duration",
              key: "1633514261",
              title: this.dataLang["reg_contract_main_45"],
              align: "center",
              width: "4%",

              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div class={"text-center"}>{column.title}</div>
                  </div>
                );
              },
              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                  <span
                    title={
                      row.contracts__duration +
                      " " +
                      this.dataLang["reg_contract_edit_4"] +
                      "."
                    }
                  >
                    {row.contracts__duration}{" "}
                    {this.dataLang["reg_contract_edit_4"]}.
                  </span>
                );
              },
            },
            {
              field: "contracts__run",
              key: "163315261",
              title: this.dataLang["reg_contract_main_46"],
              align: "center",
              width: "4%",

              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div style={"height: 20px"}></div>
                    <div class={"text-center"}>{column.title}</div>
                    <BaseSelect
                      vModel={this.selectsFilter.odometr}
                      onInput={(e, w) => {
                        if (
                          !this.filter.find(
                            (x) =>
                              x.field == "contracts__odometr_end_updated_at"
                          )
                        ) {
                          this.filter.push({
                            field: "contracts__odometr_end_updated_at",
                            value: e.value,
                            operator: e.operator,
                          });
                        } else {
                          this.filter[
                            this.filter.findIndex(
                              (x) =>
                                x.field == "contracts__odometr_end_updated_at"
                            )
                          ].operator = e.operator;
                        }
                      }}
                      style={"width: 100%"}
                      label={"label"}
                      placeholder={""}
                      id={"id"}
                      selectLabel={""}
                      deselectLabel={""}
                      options={[
                        {
                          label: this.dataLang["yes"],
                          value: "s_nowDateTime",
                          operator: "<",
                        },
                        {
                          label: this.dataLang["no"],
                          value: "s_nowDateTime",
                          operator: ">",
                        },
                      ]}
                    ></BaseSelect>
                  </div>
                );
              },
            },
            {
              field: "contracts__total",
              key: "1633122261",
              title: this.dataLang["reg_contract_main_47"],
              align: "center",
              width: "4%",

              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div class={"text-center"}>{column.title}</div>
                  </div>
                );
              },
              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                  <span title={row?.contracts__total}>
                    {row?.contracts__total}
                  </span>
                );
              },
            },
          ],
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.top-line-custom {
  position: absolute;
  display: flex;
  justify-content: space-between;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 14px;
  color: white;
  width: 65%;
}
</style>
